module.exports = __webpack_public_path__ + "img/platform-activities-in-top.e836b32c.png";